import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [show, setShow] = useState(false);
  const pendingConsent = !localStorage.getItem("ps_cookie_consent");

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed right-5 z-[60] w-11 h-11 flex items-center justify-center bg-[#F97316] text-white shadow-lg shadow-black/30 hover:bg-[#ea6a06] hover:-translate-y-0.5 transition-all duration-150 ${pendingConsent ? "bottom-32 md:bottom-24" : "bottom-5"}`}
      aria-label="Back to top"
      data-testid="back-to-top-btn"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
